import { Lightning } from '@lightningjs/sdk';
import { getImageTextureObj } from 'support/generalUtils';

const imagePath = 'static/images/login_loading_indicator.svg';

export interface LoginLoadingSpinnerTemplateSpec
  extends Lightning.Component.TemplateSpec {
  show: boolean;
  size: number;
}

export default class LoginLoadingSpinner
  extends Lightning.Component<LoginLoadingSpinnerTemplateSpec>
  implements
    Lightning.Component.ImplementTemplateSpec<LoginLoadingSpinnerTemplateSpec>
{
  private _animation: Lightning.types.Animation | null = null;

  set show(value: boolean) {
    if (this._animation) {
      value ? this._animation.start() : this._animation.stop();
    }

    this.patch({
      visible: value,
    });
  }

  set size(size: number) {
    this.patch(getImageTextureObj(imagePath, size, size));
  }

  static override _template(): Lightning.Component.Template<LoginLoadingSpinnerTemplateSpec> {
    return {
      mount: 0.5,
      rect: true,
    };
  }

  override _enable() {
    if (this._animation) return;

    this._animation = this.animation({
      duration: 1,
      repeat: -1,
      stopMethod: 'immediate',
      actions: [
        {
          p: 'rotation',
          v: { sm: 0, 0: 0, 1: 2 * Math.PI },
        },
      ],
    });
    this._animation.start();
  }
}
